export const CHECKOUT_SET_SELECTED_DELIVERY_DATE = 'CHECKOUT_SET_SELECTED_DELIVERY_DATE';
export const CHECKOUT_SET_ORDER_MARKING = 'CHECKOUT_SET_ORDER_MARKING';
export const CHECKOUT_SET_PARTIAL_DELIVERIES = 'CHECKOUT_SET_PARTIAL_DELIVERIES';
export const CHECKOUT_SET_RESELLER = 'CHECKOUT_SET_RESELLER';

export const CONSUMER_ORDER_RECEIVE = 'CONSUMER_ORDER_RECEIVE';
export const CONSUMER_ORDER_ERROR = 'CONSUMER_ORDER_ERROR';
export const CONSUMER_ORDER_CHANGE_MODE = 'CONSUMER_ORDER_CHANGE_MODE';
export const CONSUMER_ORDER_CHANGE_CURRENTPAGE = 'CONSUMER_ORDER_CHANGE_CURRENTPAGE';
export const CONSUMER_ORDER_SET_ORDER = 'CONSUMER_ORDER_SET_ORDER';

export const ACTIVE_CONSUMER_ORDER_RECEIVE = 'ACTIVE_CONSUMER_ORDER_RECEIVE';
export const ACTIVE_CONSUMER_ORDER_ERROR = 'ACTIVE_CONSUMER_ORDER_ERROR';
export const ACTIVE_CONSUMER_ORDER_CHANGE_MODE = 'ACTIVE_CONSUMER_ORDER_CHANGE_MODE';
export const ACTIVE_CONSUMER_ORDER_CHANGE_CURRENTPAGE = 'ACTIVE_CONSUMER_ORDER_CHANGE_CURRENTPAGE';
export const ACTIVE_CONSUMER_ORDER_SET_ORDER = 'ACTIVE_CONSUMER_ORDER_SET_ORDER';
export const ACTIVE_CONSUMER_ORDER_RECEIVE_ORDER = 'ACTIVE_CONSUMER_ORDER_RECEIVE_ORDER';

export const PRODUCT_INFO_TAB_SET_ACTIVE_TAB = 'PRODUCT_INFO_TAB_SET_ACTIVE_TAB';

export const FAVOURITES_SET_LISTS = 'FAVOURITES_SET_LISTS';

export const GENERIC_EXPORT_LOAD = 'GENERIC_EXPORT_LOAD';
export const GENERIC_EXPORT_LOAD_ERROR = 'GENERIC_EXPORT_LOAD_ERROR';
export const GENERIC_EXPORT_RECEIVE = 'GENERIC_EXPORT_RECEIVE';
export const GENERIC_EXPORT_STORE_TYPE = 'GENERIC_EXPORT_STORE_TYPE';
export const GENERIC_EXPORT_STORE_TYPE_INDEX = 'GENERIC_EXPORT_STORE_TYPE_INDEX';
export const GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS = 'GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS';

export const OFFERPAGE_RECEIVE = 'OFFERPAGE_RECEIVE';
export const OFFERPAGE_SET_DATE = 'OFFERPAGE_SET_DATE';
export const OFFERPAGE_SET_LIST = 'OFFERPAGE_SET_LIST';

export const CHECKOUT_RECEIVE = 'CHECKOUT_RECEIVE';
export const CHECKOUT_SET_DELIVERY_COST = 'CHECKOUT_SET_DELIVERY_COST';
export const SEARCH_RESULT_RECEIVE = 'SEARCH_RESULT_RECEIVE';

export const INVOICE_RECEIVE = 'INVOICE_RECEIVE';
export const INVOICE_ERROR = 'INVOICE_ERROR';
export const INVOICE_CHANGE_MODE = 'INVOICE_CHANGE_MODE';
export const INVOICE_CHANGE_CURRENTPAGE = 'INVOICE_CHANGE_CURRENTPAGE';
export const INVOICE_SET_ORDER = 'INVOICE_SET_ORDER';

export const BACK_ORDERS_RECEIVE = 'BACK_ORDERS_RECEIVE';
export const BACK_ORDERS_ERROR = 'BACK_ORDERS_ERROR';

export const SHIPMENT_RECEIVE = 'SHIPMENT_RECEIVE';
export const SHIPMENT_ERROR = 'SHIPMENT_ERROR';
export const SHIPMENT_CHANGE_MODE = 'SHIPMENT_CHANGE_MODE';
export const SHIPMENT_CHANGE_CURRENTPAGE = 'SHIPMENT_CHANGE_CURRENTPAGE';
export const SHIPMENT_SET_ORDER = 'SHIPMENT_SET_ORDER';

export const RETURN_LIST_RECEIVE = 'RETURN_LIST_RECEIVE';
export const RETURN_LIST_ERROR = 'RETURN_LIST_ERROR';
export const RETURN_LIST_CHANGE_MODE = 'RETURN_LIST_CHANGE_MODE';
export const RETURN_LIST_CHANGE_CURRENTPAGE = 'RETURN_LIST_CHANGE_CURRENTPAGE';
export const RETURN_LIST_SET_RETURN = 'RETURN_LIST_SET_RETURN';
export const RETURN_LIST_FILTER_CHANGE = 'RETURN_LIST_FILTER_CHANGE';
export const RETURN_LIST_SET_SEARCH_TEXT = 'RETURN_LIST_SET_SEARCH_TEXT';
export const RETURN_LIST_SET_SORT_BY = 'RETURN_LIST_SET_SORT_BY';

export const RETURN_LIST_RECEIVE_CLOSED = 'RETURN_LIST_RECEIVE_CLOSED';
export const RETURN_LIST_CHANGE_MODE_CLOSED = 'RETURN_LIST_CHANGE_MODE_CLOSED';
export const RETURN_LIST_CHANGE_CURRENTPAGE_CLOSED = 'RETURN_LIST_CHANGE_CURRENTPAGE_CLOSED';
export const RETURN_LIST_SET_RETURN_CLOSED = 'RETURN_LIST_SET_RETURN_CLOSED';
export const RETURN_LIST_FILTER_CHANGE_CLOSED = 'RETURN_LIST_FILTER_CHANGE_CLOSED';
export const RETURN_LIST_SET_SEARCH_TEXT_CLOSED = 'RETURN_LIST_SET_SEARCH_TEXT_CLOSED';
export const RETURN_LIST_SET_SORT_BY_CLOSED = 'RETURN_LIST_SET_SORT_BY_CLOSED';

export const RETURN_RECEIVE = 'RETURN_RECEIVE';
export const RETURN_CHANGE_MODE = 'RETURN_CHANGE_MODE';
export const RETURN_SET_ERROR = 'ETURN_SET_ERROR';
export const RETURN_RECEIVE_ORDER_ARTICLES = 'RETURN_RECEIVE_ORDER_ARTICLES';

export const CREDIT_ORDER_RECEIVE = 'CREDIT_ORDER_RECEIVE';
export const CREDIT_ORDER_ERROR = 'CREDIT_ORDER_ERROR';
export const CREDIT_ORDER_CHANGE_MODE = 'CREDIT_ORDER_CHANGE_MODE';
export const CREDIT_ORDER_CHANGE_CURRENTPAGE = 'CREDIT_ORDER_CHANGE_CURRENTPAGE';
export const CREDIT_ORDER_SET_ORDER = 'CREDIT_ORDER_SET_ORDER';